jQuery(function($) {

  var l_window = parseInt($(window).width());
  const header = $('#masthead'); 
  var LARGEUR_MAX_MOBILE = 1350;



/*  ***************************
    SCROLL FIXED MENU 
  ******************************** */


  var CpegHeader = document.querySelector("header.site-header");
   function isNavVisible(CpegHeader) {
    return (CpegHeader.classList.contains('open-s-menu') ? true : false );
   }
   var options = {
    offset : 60,
      tolerance : {
          up : 5,
          down : 0
      },
    onUnpin: function() {
      if ( isNavVisible(CpegHeader) ) {
        this.elem.classList.remove(this.classes.unpinned);
        this.elem.classList.add(this.classes.pinned);
      }
      else {
        this.elem.classList.add(this.classes.unpinned);
        this.elem.classList.remove(this.classes.pinned);
      }
    }
  };

  var headroom  = new Headroom(CpegHeader,options);


  // initialise
  headroom.init();





     $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-0;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });


  /* Gestion des sous-menus */


   /*****************************************************/
      /************** BTN OPEN / CLOSE SUB MENU ****/
    /*****************************************************/

   var $prev_menu_open = '';
   var $prev_dest_menu_open = '';
   var $active_menu = '';
   var $dest_sub_menu = '';


   function active_sub_menu($active_menu,$dest_sub_menu){

    if($prev_menu_open != '' && ($prev_menu_open != $active_menu)){
         disable_sub_menu($prev_menu_open, $prev_dest_menu_open);
    }

    $('.site-header').addClass('open-s-menu');
    $('.container_menu .main-nav-menu-item.toDoHover').removeClass('is-hover');
    $('.header-sub').removeClass('active');
    if($active_menu){
         $active_menu.addClass('is-hover');
         $active_menu.find('.nav__main_btn').attr('aria-expanded', true);
    } 
   
    $dest_sub_menu.addClass('active');
    // Remove previous hover actions
    // $dest_sub_menu.find('.is-hover').removeClass('is-hover');
    // $('.AppearRight.to_visible').removeClass('to_visible');
  }

  function disable_sub_menu($active_menu,$dest_sub_menu){
     if($active_menu){
      $active_menu.removeClass('is-hover');
       $active_menu.find('.nav__main_btn').attr('aria-expanded', false);
     }
    $dest_sub_menu.removeClass('active');
    $('.site-header').removeClass('open-s-menu');
   // header.removeClass('bg_for_hover');
  }

    $( ".container_menu .main-nav-menu-item.toDoHover button" ).click(function(e) {
        console.log("hehee");
        $active_menu = $(this).parent();
        

        if($(this).attr('aria-expanded') == 'false'){
            // On ouvre ce menu
            $dest_sub_menu = $('.header-sub[data-link-id="'+$(this).attr('data-link-id')+'"]'); 
             active_sub_menu($active_menu, $dest_sub_menu);
            
             $prev_menu_open = $active_menu;
             $prev_dest_menu_open = $('.header-sub[data-link-id="'+$(this).attr('data-link-id')+'"]');
            
        }else{
            // On ferme ce menu 
             disable_sub_menu($active_menu, $dest_sub_menu);
        }
       
        e.preventDefault();
    });

    /* Close Btn Desktop Only */
    $( ".container_menu .close-desktop-menu" ).click(function(e) {
      if($prev_menu_open != '') disable_sub_menu($prev_menu_open,$prev_dest_menu_open);    
    });


    
    // Click sur retour dans sous-menu pour mobile // 
     $( "button.header-sub-titleContainer" ).click(function(e) {
        if($(this).attr('data-level') == 'sub-sub'){
           disable_sub_sub_menu_mobile($active_menu, $dest_sub_menu);
        }else{
           disable_sub_menu($active_menu, $dest_sub_menu);
        }
    });

   

    $('.menu-toggle').click(function(e){
        if($(this).attr('aria-expanded') == 'false'){
            if($active_menu != ''){
            // On desable les sub-menu et les sub-sub-menu avant de fermer
             disable_sub_menu($active_menu, $dest_sub_menu);
             }
         }
    });
    

  // $( ".list-sub-menu li" ).each(function( index ) {
  //   if($( this ).hasClass('is-hover'));
  //    let group = $(this).find('a').attr('data-link-group');
  //    console.log("group" + group);
  //    $(`button[data-link-id="smenu-${group}"]`).trigger("click");
     
  // });




    /*  ***************************
    SWIPER GALERIE TOP HOME
  ******************************** */
     var swiper = new Swiper(".swiper_top_home", {
          spaceBetween: 0,
          speed: 800,
          effect: "fade",
          fadeEffect: {
            crossFade: true
          },
          autoplay: {
           delay: 5000,
         },
    });



  /*  ***************************
    ANIMATION GSAP DESKTOP
  ******************************** */

 gsap.registerPlugin(ScrollTrigger);
const mm = gsap.matchMedia();

mm.add("(min-width: 1024px)", () => {
  const section = document.querySelector(".ExpertisePinSection");
  if (!section) return;

  const items = gsap.utils.toArray(".ExpertisePinSection .ExpertiseItem");
  const arrows = gsap.utils.toArray(".ExpertisePinSection .ExpertiseItem-Arrow");
  const icons = gsap.utils.toArray(".ExpertisePinSection .ExpertiseItem-Icon i");

  // état initial
  gsap.set(items, {
    opacity: 0,
    y: 80,
    filter: "blur(18px)"
  });

  gsap.set(arrows, {
    opacity: 0,
    x: -100, 
    y:100
  });

  gsap.set(icons, {
    opacity: 0,
    y: 90,
    filter: "blur(10px)"
  });

  const tl = gsap.timeline({
    defaults: {
      ease: "power2.out"
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
     // end: "+=1800",
     // scrub: 0.8,
     // pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true
      // markers: true
    }
  });

  // bloc 1
  tl.to(items[0], {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 0.75
  })
 // .to({}, { duration: 0.18 })
  .to(icons[0], {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 0.3
  }, "-=0.10")
  .to(arrows[0], {
    opacity: 1,
    x: 0,
    y:0,
    duration: 0.5
  }, "-=0.2")

  // bloc 2
//  .to({}, { duration: 0.22 })
  .to(items[1], {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 0.75
  })
//  .to({}, { duration: 0.18 })
  .to(icons[1], {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 0.3
   }, "-=0.10")
  .to(arrows[1], {
    opacity: 1,
    x: 0,
    y:0,
    duration: 0.5
  }, "-=0.2")

  // bloc 3
//  .to({}, { duration: 0.22 })
  .to(items[2], {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 0.75
  })
  //.to({}, { duration: 0.18 })
  .to(icons[2], {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 0.3
    }, "-=0.10")
  .to(arrows[2], {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    duration: 0.25
  }, "-=0.01");

  window.addEventListener("load", () => ScrollTrigger.refresh());
});

     /***********************************************/   
      /******** SLIDER ONLY ON MOBILE // LIST EXPERTISE / HOME ************/
      /***********************************************/
        var swipersExpertises = []; 
        var ExpertisesInitialized = false;

        function swiperCard() {
          const sliders = document.querySelectorAll(".slider-expertise-js");

          // Si fenêtre < 600px → on initialise si pas déjà fait
          if (window.innerWidth < 1024) {
            if (!ExpertisesInitialized) {
              ExpertisesInitialized = true;

              sliders.forEach((slider, index) => {
                swipersExpertises[index] = new Swiper(slider, {
                  slidesPerView: 1,
                  centeredSlides: true,
                  spaceBetween: 16,
                  pagination: {
                    el: '.swiper-bullet-pagination',
                    clickable: true
                  },
                  autoplay: {
                    delay: 6000,
                    disableOnInteraction: false
                  },

                });
              });
            }

          // Sinon → destroy tous les sliders si déjà init
          } else if (ExpertisesInitialized) {
            swipersExpertises.forEach(swiper => swiper.destroy(true, true));
            swipersExpertises = [];
            ExpertisesInitialized = false;
          }
        }

        swiperCard();
        window.addEventListener("resize", swiperCard);


          /***********************************************/   
      /******** SLIDER REA GALERIE ************/
      /***********************************************/

           var swiper_rea_g = new Swiper(".swiper_galery_rea", {
              spaceBetween: 20,
              speed: 800,
              autoplay: {
               delay: 5000,
             },
              pagination: {
                  el: '.swiper-bullet-pagination',
                  clickable: true
              },
        });


       /***********************************************/   
      /******** SLIDER LAST REA ************/
      /***********************************************/

        var swiper_last_rea = new Swiper(".js-slider-last-rea", {
              slidesPerView: 1,
              slidesPerGroup:1,
              spaceBetween: 20,
              speed: 800,
              autoplay: {
               delay: 5000,
             },
              pagination: {
                  el: '.swiper-bullet-pagination',
                  clickable: true
              },
               breakpoints: {
                550: {
                  spaceBetween:40,
                  slidesPerView: 2,
                  slidesPerGroup:2,
                },
                1024: {
                  spaceBetween:40,
                  slidesPerView: 3,
                  slidesPerGroup:3,
                },
                 1250: {
                  spaceBetween:81,
                  slidesPerView: 3,
                  slidesPerGroup:3,
                },
            }
        });



           



      ////////////////
    //// GLOBAL accordion 
   ///////////////
   $('.accordion-section-content').hide();
  
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////


    /* **************************************************  */
        /* FORMULAIRE CONTACT SUR LE CÔTÉ */
    /* **************************************************  */



        
    /**********************************************************************/
        /*************** SLIDER CLIENT QUI DEFILENT SAME ANIM ****************/
    /**********************************************************************/

    var swiper_home_evt = new Swiper('.js-swiper-features-logo-customers', {
         slidesPerView: 2,
         speed: 5000,
         spaceBetween:20,
         allowTouchMove: false,
         loop:true,
         autoplay: {delay: 0,pauseOnMouseEnter: false, disableOnInteraction: false},
          breakpoints: {
            640: {
             spaceBetween:10,
              slidesPerView: 3,
            },    
            768: {
                spaceBetween:20,
              slidesPerView: 4,
            },
            1550: {
              spaceBetween:30,
              slidesPerView: 5,
            },
            1250: {
             spaceBetween:40,
              slidesPerView: 6,
            },
          }

    });
    


    var button_adherer = $('#open_contact_form');
    var block_aside = $('.ContactAside');
    var block_aside_inner = $('.ContactAside-Inner');
    if(l_window < LARGEUR_MAX_MOBILE+1){
      block_aside_inner.hide();
    }
    button_adherer.click(function() {
      l_window = parseInt($(window).width());
       if($(this).attr('aria-expanded') == 'false'){
          block_aside.addClass('to_open');
          $(this).attr('aria-expanded', 'true');
       }else{
          block_aside.removeClass('to_open');
          $(this).attr('aria-expanded', 'false');
       }

      if(l_window > LARGEUR_MAX_MOBILE+1){

      }else{
        block_aside_inner.slideToggle(500);
      }

    });

    $('.ContactAside-Close--js').click(function(e) {
         $( "#open_contact_form" ).trigger( "click" );
    });

    


    
     ////////////////////
     // Animation Texte qui apparait //
    ////////////////////
    



  document.querySelectorAll(".txt_to_discover").forEach((element) => {
    const originalText = element.textContent;
    element.setAttribute("aria-label", originalText);

    // On récupère le HTML pour conserver les <br>
    const html = element.innerHTML;

    // Découpe en gardant les <br> dans le flux
    const parts = html.split(/(<br\s*\/?>)/gi);

    element.innerHTML = "";

    parts.forEach((part) => {
      // Si c'est un <br>, on le réinjecte tel quel
      if (/<br\s*\/?>/i.test(part)) {
        element.appendChild(document.createElement("br"));
        return;
      }

      // Sinon on traite le texte en gardant mots + espaces
      const temp = document.createElement("div");
      temp.innerHTML = part;
      const text = temp.textContent || "";

      const tokens = text.match(/\S+|\s+/g) || [];

      tokens.forEach((token) => {
        // espaces
        if (/^\s+$/.test(token)) {
          element.appendChild(document.createTextNode(token));
          return;
        }

        // mot
        const wordSpan = document.createElement("span");
        wordSpan.className = "word";

        Array.from(token).forEach((char) => {
          const charSpan = document.createElement("span");
          charSpan.className = "char";
          charSpan.textContent = char;
          wordSpan.appendChild(charSpan);
        });

        element.appendChild(wordSpan);
      });
    });

    const chars = element.querySelectorAll(".char");

    gsap.set(chars, {
      opacity: 0,
      y: 8,
      filter: "blur(6px)"
    });

    ScrollTrigger.create({
      trigger: element,
      start: "top bottom",

      onEnter: () => {
        gsap.to(chars, {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 0.5,
          ease: "power2.out",
          stagger: 0.03,
          overwrite: "auto"
        });
      },

      onLeaveBack: () => {
        gsap.set(chars, {
          opacity: 0,
          y: 8,
          filter: "blur(6px)"
        });
      }
    });
  });

  ScrollTrigger.refresh();



   

    /* Aniamtion des hightligts dans les titres  */

    document.querySelectorAll(".move_txt").forEach((element) => {

        const rotation = element.classList.contains("rotate_positif") ? "2deg" : "-2deg";
        const top_elt = element.classList.contains("rotate_positif") ? "2" : "2";
        const left_decalage = element.classList.contains("special_title") ? "0" : "10";

        // état initial
        gsap.set(element, {
          opacity: 0,
          y: 8
        });

        ScrollTrigger.create({
          trigger: element,
          start: "top bottom",

          onEnter: () => {
            gsap.fromTo(
              element,
              { opacity: 0, y: 30, x: left_decalage },
              {
                x: left_decalage,
                opacity: 1,
                rotate: rotation,
                y: top_elt,
                duration: 1,
                filter: "blur(0px)",
                ease: "power2.out",
                stagger: 0.03,
                overwrite: "auto"
              }
            );
          },

          onLeaveBack: () => {
            gsap.set(element, {
              opacity: 0,
              y: 30
            });
          }
        });

      });

    


     ////////////////////
     // Animation Pin dans single réa //
    ////////////////////
  

    mm.add("(min-width: 768px) and (min-height: 850px)", () => {
      const inner = document.querySelector(".mRea_Answer-inner");
      const rightCol = document.querySelector(".mRea_Answer-R");

      if (inner && rightCol) {
        ScrollTrigger.create({
          trigger: inner,
          start: "top top+=100",
          end: "bottom bottom",
          pin: rightCol,
          invalidateOnRefresh: true
          // markers: true
        });
      }
  });
      
    mm.add("(min-width: 768px)", () => {

     

      // Changement de couleur des blocs icône
      gsap.utils.toArray(".mRea_Answer .ExpertiseItem").forEach((icon) => {
        ScrollTrigger.create({
          trigger: icon,
          start: "top 55%",
          end: "bottom 45%",
          toggleClass: {
            targets: icon,
            className: "is-active"
          }
          // markers: true
        });
      });

      window.addEventListener("load", () => ScrollTrigger.refresh());
    });


     ////////////////////
     // Animation Des images au scroll dans la page Equipe //
    ////////////////////
    

   

  document.querySelectorAll(".AnimImg").forEach((block) => {
    const belowWrap = block.querySelector(".AnimImg-imgbelow");
    const belowImg = block.querySelector(".AnimImg-imgbelow img");

    gsap.set(belowWrap, {
      clipPath: "inset(100% 0 0 0)"
    });

    gsap.set(belowImg, {
      scale: 1.12,
      filter: "blur(12px)"
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top 25%",
        toggleActions: "play reverse play reverse"
      }
    })
    .to(belowWrap, {
      clipPath: "inset(0% 0 0 0)",
      duration: 1.1,
      ease: "power3.out"
    })
    .to(belowImg, {
      scale: 1,
      filter: "blur(0px)",
      duration: 1.1,
      ease: "power3.out"
    }, 0);
  });





     /*********************************/
      /** MASONRY POUR LES REALISATIONS **/
    /*********************************/
   

    if($('.container_masonry_rea').length){

      var $container_project_masonry = $('.container_masonry_rea');
      var grid_isotope;
      var class_filter_init = '*';

      $container_project_masonry.imagesLoaded(function () {

          grid_isotope = $container_project_masonry.isotope({
              itemSelector: '.grid-item',
              percentPosition: true,
              filter: class_filter_init,
              layoutMode: 'fitRows'
          });

      });

      $('select.filter-cat-rea').niceSelect();

      $('select.filter-cat-rea').on('change', function() {

          var filterValue = this.value;

          grid_isotope.isotope({ filter: filterValue });

            ScrollTrigger.refresh();

          // Vérifie le nombre d'éléments visibles
          var filteredItems = grid_isotope.data('isotope').filteredItems.length;

          if(filteredItems == 0){
              $('.no-results-filter').show();
          } else {
              $('.no-results-filter').hide();
          }

      });

  }



  // Image à gauche 
mm.add("(min-width: 1024px)", () => {

const sections = gsap.utils.toArray(".mB_txt_wimg--inner.img_left_txt_right");

sections.forEach((section) => {

  const image = section.querySelector(".mB_txt_wimg-img img");

  if (!image) return;

  gsap.set(image, {
    opacity: 0,
    x: -80,
    filter: "blur(14px)",
    scale: 1.05
  });

  gsap.to(image, {
    opacity: 1,
    x: 0,
    scale: 1,
    filter: "blur(0px)",
    duration: 0.9,
    ease: "power2.out",
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play reverse play reverse"
      // markers: true
    }
  });

});

  // Image à droite 

  const sections2 = gsap.utils.toArray(".mB_txt_wimg--inner.txt_left_img_right");

  sections2.forEach((section2) => {

    const image2 = section2.querySelector(".mB_txt_wimg-img img");

    if (!image2) return;

    gsap.set(image2, {
      opacity: 0,
      x: 80,
      filter: "blur(14px)",
      scale: 1.05
    });

    gsap.to(image2, {
      opacity: 1,
      x: 0,
      scale: 1,
      filter: "blur(0px)",
      duration: 0.9,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section2,
        start: "top 80%",
        toggleActions: "play reverse play reverse"
        // markers: true
      }
    });

  });

 }); // fin match media

});


